import React, { useEffect, useState } from 'react';
import apis from '../../utils/apis';
import httpAction from '../../utils/httpAction';
import { CardSkeleton } from '../../components/common/Skeleton';

const card = { background:'#fff', borderRadius:20, padding:20, boxShadow:'0 12px 30px rgba(15,23,42,.06)' };
const inputStyle = { width:'100%', padding:10, border:'1px solid #d0d5dd', borderRadius:10 };

export default function Inquiries() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const result = await httpAction({ url: apis().contactList, silent: true });
    if (result?.status) setList(result.list || []);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const updateInquiry = async (item, patch) => {
    const result = await httpAction({ url: `${apis().contactUpdate}/${item._id}`, method:'PUT', body: { ...patch } });
    if (result?.status) load();
  };

  const deleteInquiry = async (item) => {
    if (!window.confirm('Delete this inquiry?')) return;
    const result = await httpAction({ url: `${apis().contactDelete}/${item._id}`, method:'DELETE' });
    if (result?.status) load();
  };

  return (
    <div style={{ display:'grid', gap:24 }}>
      <div>
        <h2 style={{ margin:0 }}>Inquiries</h2>
        <p style={{ color:'#667085', marginTop:8 }}>Track, assign, and update contact form submissions.</p>
      </div>
      {loading ? <CardSkeleton count={4} height={190} /> : (
        <div style={{ display:'grid', gap:14 }}>
          {list.map((item) => (
            <div key={item._id} style={card}>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 220px 220px', gap:16 }}>
                <div>
                  <div style={{ fontWeight:800, fontSize:18 }}>{item.name}</div>
                  <div style={{ color:'#667085', marginTop:4 }}>{item.email || 'No email'} {item.phone ? `• ${item.phone}` : ''}</div>
                  <div style={{ marginTop:8, fontWeight:700 }}>{item.subject || 'General inquiry'}</div>
                  <p style={{ color:'#475467', marginTop:8 }}>{item.message}</p>
                  <small style={{ color:'#98a2b3' }}>{new Date(item.createdAt).toLocaleString()}</small>
                </div>
                <div style={{ display:'grid', gap:10 }}>
                  <select value={item.status} onChange={(e)=>updateInquiry(item, { status: e.target.value })} style={inputStyle}>
                    <option value='new'>New</option>
                    <option value='contacted'>Contacted</option>
                    <option value='closed'>Closed</option>
                  </select>
                  <input value={item.assignedTo || ''} onChange={(e)=>updateInquiry(item, { assignedTo: e.target.value })} placeholder='Assigned to' style={inputStyle} />
                  <button onClick={()=>deleteInquiry(item)} style={{ border:'1px solid #f04438', background:'#fff', color:'#f04438', borderRadius:10, padding:10 }}>Delete</button>
                </div>
                <textarea defaultValue={item.notes || ''} onBlur={(e)=>updateInquiry(item, { notes: e.target.value })} rows={6} style={{ ...inputStyle, resize:'vertical' }} placeholder='Internal notes' />
              </div>
            </div>
          ))}
          {!list.length && <div style={{ color:'#667085' }}>No inquiries yet.</div>}
        </div>
      )}
    </div>
  );
}
